import {
  PluginEquifaxInDepthTradingHistoryForm,
  PluginEquifaxInDepthTradingHistoryFormResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxInDepthTradingHistoryForm = (
  constructPost: ConstructPost,
  data: PluginEquifaxInDepthTradingHistoryForm,
): Promise<
  | NonPaginatedResponse<PluginEquifaxInDepthTradingHistoryFormResponse>
  | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginEquifaxInDepthTradingHistoryFormResponse>
  >(`${PLUGIN_BASE_PATH}/equifax-in-depth-trading-history-form`, { data });
